declare namespace $ {

	export class $shm_hitalama_text_editor extends $mol_textarea {
		paste_listener( ): any
		owner( ): $giper_baza_entity
		images_enabled( ): boolean
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map